import api from "api";

const financial = {
    /**
     * Aceita period ou start_date/end_date, e event_id. Sem parâmetro nenhum
     * responde o histórico completo. Saldo e valor a receber ignoram o recorte
     * de propósito — são fotografias do agora, não movimento de período.
     */
    get: (params) => {
        return api().get('/financial/transaction-summary', {
            params: { ...params }
        });
    },

    getBanks: () => {
        return api().get('/bank-account/banks');
    },

    getWithdrawData: (params) => {
        return api().get('/financial/withdraw', {
            params: { ...params }
        });
    },

    getWithdrawDataWithLimit: () => {
        return api().get('/financial/withdraw', {
            params: { limit: 5 }
        });
    },

    getStatementBalanceWithLimit: (params) => {
        return api().get('/statement-balance', {
            params: { ...params, limit: 5 }
        });
    },

    /**
     * Transações dos pedidos que o produtor vendeu.
     *
     * Não confundir com `/transactions`, que lista as compras do próprio
     * usuário — lá o `user_id` da transação é o comprador.
     */
    getOrderTransactions: (params) => {
        return api().get('/financial/transactions', {
            params: { ...params }
        });
    },

    exportOrderTransactions: (params) => {
        return api().get('/financial/transactions/export', {
            params: { ...params },
            responseType: 'blob'
        });
    },

    getStatementBalance: (params) => {
        return api().get('/statement-balance', {
            params: { ...params }
        });
    },

    /**
     * Devolve o CSV cru. O backend já manda o BOM e o Content-Type, então o
     * download não passa pelo helper downloadBlob — ele acrescentaria um
     * segundo BOM, que aparece como lixo na primeira célula.
     */
    exportStatementBalance: (params) => {
        return api().get('/statement-balance/export', {
            params: { ...params },
            responseType: 'blob'
        });
    },

    withdraw: (payload) => {
        return api().post('/financial/withdraw', payload);
    },

    registerBankAccount: (payload) => {
        return api().post('/bank-account', payload);
    },

    getBankAccount: () => {
        return api().get('/bank-account');
    },

    editBankAccount: (accountId, payload) => {
        return api().put(`/bank-account/${accountId}`, payload);
    },

    deleteBankAccount: (accountId) => {
        return api().delete(`/bank-account/${accountId}`);
    },

    myInvoices: (page) => {
        return api().get(`/nfse/my-nfse?page=${page}`);
    },

    receiptSchedule: (mounth, year) => {
        return api().get(`/financial/scheduled-payments?month=${mounth}&year=${year}`);
    }
}

export default financial;